import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Container,
  LinearProgress,
  Paper,
  useMediaQuery,
  Tab,
  Tabs,
  Divider,
  Avatar,
  CardContent,
  Card,
  Rating,
  createTheme,
} from "@mui/material";
import logo from "../../assets/images/Logo.png";
import styles from "./HomeNew.module.css";
import profile_image1 from "../../assets/images/profile-picture 1.jpg";
import profile_image2 from "../../assets/images/profile-picture 2.jpg";
import profile_image3 from "../../assets/images/profile-picture 3.jpg";
import profile_image4 from "../../assets/images/profile-picture 4.jpg";
import man from "../../assets/images/Middile Men.png";
import value from "../../assets/images/Business Wo.jpg";
import why from "../../assets/images/Who We11.jpg";
import who from "../../assets/images/Why Choose Us 2.jpg";
import what from "../../assets/images/Who We11.jpg";
import our from "../../assets/images/Why Choose Us 2.jpg";
import { useNavigate } from "react-router-dom";
import disccusion_image from "../../assets/images/Modern-Business-Metting.jpg";
import review_image from "../../assets/images/One Image.jpg";
import write from "../../assets/images/White GIF-One.gif";
import responsive_web from "../../assets/images/Responsive Web.jpg";
import web_design from "../../assets/images/App Development One.jpg";
import digital_marketing from "../../assets/images/Digital Marketing One.jpg";
import Profile_picture from "../../assets/images/Happy Girl V2.jpg";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { GoLightBulb } from "react-icons/go";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiBuildings } from "react-icons/pi";
import { GoTasklist } from "react-icons/go";
import { LiaUserTieSolid } from "react-icons/lia";
import { PiSailboat } from "react-icons/pi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { ThemeProvider, width } from "@mui/system";
import WordAnimation from "./WordAnimation";
import { RxHamburgerMenu } from "react-icons/rx";
import React, { useEffect, useState } from "react";
import { IoStar } from "react-icons/io5";
import { RxPlus } from "react-icons/rx";
import { IoStarOutline } from "react-icons/io5";
import { IoStarHalfOutline } from "react-icons/io5";
import Fade from "react-reveal/Fade";
import { keyframes } from "@emotion/react";
import Carousel from "react-material-ui-carousel";
import { FaUser } from "react-icons/fa6";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import SwipeableViews from "react-swipeable-views";
import { Star } from "@mui/icons-material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0, // Extra small devices (phones)
      sm: 600, // Small devices (tablets)
      md: 900, // Medium devices (small laptops)
      lg: 1200, // Large devices (desktops)
      lgg: 1350, // Large devices (desktops)
      xl: 1536, // Extra large devices (large desktops)
      xll: 1650, // Extra large devices (large desktops)
      xxl: 1800, // Custom breakpoint for ultra-wide screens
    },
  },
});

const Home = ({ title, color }) => {
  const naviagte = useNavigate();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [activeTab, setActiveTab] = useState(0);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabsChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleArrowClick = (direction) => {
    if (direction === "next" && tabValue < 3) {
      setTabValue(tabValue + 1);
    } else if (direction === "prev" && tabValue > 0) {
      setTabValue(tabValue - 1);
    }
  };
  const waves = keyframes`
    0%,
    100% {
      clip-path: polygon(
        0% 45%,
        16% 44%,
        33% 50%,
        54% 60%,
        70% 61%,
        84% 59%,
        100% 52%,
        100% 100%,
        0% 100%
      );
    }
    50% {
      clip-path: polygon(
        0% 60%,
        15% 65%,
        34% 66%,
        51% 62%,
        67% 50%,
        84% 45%,
        100% 46%,
        100% 100%,
        0% 100%
      );
    }
  `;
  const growAnimation = keyframes`
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  `;

  const textAnimation = keyframes`
    from {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
    }
    to {
      clip-path: polygon(0 0, 0% 1%, 0% 100%, 0% 100%);
    }
  `;

  const cursorAnimation = keyframes`
    from {
      width: 100%;
    }
    to {
      width: 0;
    }
  `;

  const [progress72, setProgress72] = useState(0);
  const [progress17, setProgress17] = useState(0);
  const [progress11, setProgress11] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 72;
    const stepTime = duration / steps;

    const interval = setInterval(() => {
      setProgress72((prev) => Math.min(prev + 1, 72));
      setProgress17((prev) => Math.min(prev + 1, 17));
      setProgress11((prev) => Math.min(prev + 1, 11));

      if (progress72 >= 72 && progress17 >= 17 && progress11 >= 11) {
        clearInterval(interval);
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [progress72]);
  const gender = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];
  const carouselItems = [
    {
      title: "What we offer!",
      content: [
        {
          heading: " Streamlined Hiring",
          text: " Our ATS simplifies every stage of the hiring process, from job posting and application tracking to interview scheduling and candidate management. Experience a seamless workflow that saves you time and reduces manual effort.",
        },
        {
          heading: " Enhanced Candidate Experience",
          text: " Our user-friendly interface ensures a positive experience for candidates, making it easy for them to apply, track their application status, and engage with your brand throughout the hiring journey.",
        },
        {
          heading: " Customizable Solutions",
          text: " Tailor our ATS to fit your unique recruitment needs with flexible features and integrations. Whether you’re a small business or a large enterprise, our platform adapts to your requirements.",
        },
      ],
    },
    {
      title: "Who We Are!",
      content: [
        {
          text: "Povital is a leader in the recruitment technology space, bringing together a team of experienced IT recruiters and professionals, software engineers, and industry innovators. Our mission is to simplify and optimize the recruitment process through technology, helping you make data-driven hiring decisions and build a successful workforce.",
        },
      ],
    },
    {
      title: "Our Values",
      content: [
        {
          heading: "Innovation",
          text: " We are committed to continuously enhancing our platform with the latest technology and features to stay ahead in the rapidly evolving recruitment landscape.",
        },
        {
          heading: "Customer Success",
          text: " We prioritize your success by providing exceptional support and ensuring our ATS meets your specific needs and expectations.",
        },
      ],
    },
  ];
  const feedbacks = [
    {
      profileImage: profile_image1,
      comment:
        "It’s easy to use. tracking of candidates and requirements is so easy and this is very interactive in both directions via the ATS with them. This improves the performance of candidates, and limits admin activity.",
      name: "Mahesh Bhat – IT Recruiter",
      names: "Mahesh Bhat",
      designation: "IT Recruiter",
      rating: 5,
      date: "27 –September 2024",
    },
    {
      profileImage: profile_image2,
      comment:
        "  My overall experience is very positive, its helping to me tracking my contract candidates and requirement along with every details also its very easy to use even afresher recruiter can use easily as per my opinion it’s  enough thank you povital.com",
      name: "Ankita Tiwari – IT Recruiter",
      names: "Ankita Tiwari",
      designation: "IT Recruiter",
      rating: 4,
      date: "  22 –September 2024",
    },
    {
      profileImage: profile_image3,
      comment:
        " The interface is user friendly and is very efficient for the recruitment process. The main features that we like about it are: 1 The main feature is user friendly interface that makes it super easy for us and an appropriate feature for an IT Recruiter and Bench Sale Recruiter.",
      name: "Nikhil Mishra – Bench Sales Recruiter",
      names: "Nikhil Mishra",
      designation: "Bench Sales Recruiter",
      rating: 5,
      date: "22 –August 2024",
    },
    {
      profileImage: profile_image4,
      comment:
        "  Having actively user of Povital Job Board and Application Tracking System (ATS) for the past few days in my role as an IT Recruiter, I'm pleased to share my first hand insights into the systems merits and advantages. Povital ATS will played a crucial role in our USA requirement operations, streamlining and smooth operation system. the user interface is user-friendly, intuitive.",
      name: "David M – Bench Sales Recruiter",
      names: "David M",
      designation: "Bench Sales Recruiter",
      rating: 3,
      date: "20 –August 2024",
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("//")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "18px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "20px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "18px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "18px ",
                fontWeight: "500",
              }}
            >
              About Us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "18px ",
                fontWeight: "500",
              }}
            >
              Contact Us
            </b>
          </a>
          <Box className={styles.login_btn} sx={{ marginLeft: "10px" }}>
            <a onClick={() => navigate("/login")}>
              Login{" "}
              <FaUser
                style={{ color: "#fff", fontSize: "14px", marginLeft: "5px" }}
              />
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("//")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "18px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "18px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "18px ",
                  fontWeight: "500",
                }}
              >
                About Us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "18px ",
                  fontWeight: "500",
                }}
              >
                Contact Us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                Login{" "}
                <FaUser
                  style={{ color: "#fff", fontSize: "14px", marginLeft: "5px" }}
                />
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Fade bottom delay={200}>
        <Grid container className={styles.banner_phase}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ textAlign: "center", marginTop: "100px" }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "20px !important",
                  md: "22px !important",
                  lg: "23px !important",
                  lgg: "25px !important",
                },
                fontFamily: "Bodoni MT Poster Compressed !important",
                // fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              UP TO 70% TIME SAVING IN RECRUITMENT LIFE
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "20px !important",
                  sm: "22px !important",
                  md: "26px !important",
                  lg: "30px !important",
                  lgg: "35px !important",
                },
                fontFamily: "Bodoni MT Poster Compressed !important",
                fontWeight: "bold",
                marginBottom: {
                  xs: "30px !important",
                  sm: "30px !important",
                  md: "40px !important",
                  lg: "50px !important",
                  lgg: "70px !important",
                },
              }}
            >
              TRACK YOUR IT TALENT FOR NEXT POSITION
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "14px !important",
                  md: "22px !important",
                },
                // fontFamily: "Bodoni MT Poster Compressed !important",
                marginBottom: "20px",
              }}
            >
              100% Free for Consultant Tracking & Submission Tracking
            </Typography>
            <Box
              mt={3}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                },
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                className={styles.btns}
                sx={{
                  mb: {
                    xs: 2,
                    sm: 2,
                    md: 0,
                  },
                }}
              >
                <span
                  className={styles.post_requirement_btn}
                  onClick={() => navigate("/login")}
                >
                  Post A Job{" "}
                  <RxPlus style={{ fontSize: "29px", marginLeft: "10px" }} />
                </span>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: {
                    xs: 2,
                    sm: 2,
                    md: 0,
                  },
                }}
              >
                {[...Array(5)].map((_, index) => (
                  <Avatar
                    key={index}
                    sx={{ width: 48, height: 48, ml: index > 0 ? -1.5 : 0 }}
                    src={`https://picsum.photos/48?random=${index}`}
                  />
                ))}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  ml: 2,
                  mb: {
                    xs: 2,
                    sm: 2,
                    md: 0,
                  },
                }}
              >
                <span>
                  {/* {[...Array(4)].map((_, index) => (
                    <Star
                      color="warning" 
                      sx={{ mr: 1, fontSize: "30px" }}
                      key={index}
                    />
                  ))} */}
                  <Rating
                    name="half-rating-read"
                    defaultValue={4.5}
                    precision={0.5}
                    readOnly
                    sx={{
                      mr: 1,
                      "& .MuiRating-icon": {
                        fontSize: "2rem !important", // Increase this value as needed
                      },
                    }}
                    size="large"
                  />
                </span>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "11px !important",
                      md: "18px !important",
                    },
                  }}
                >
                  <b>22.2k</b> Users with review 4.5 of 5
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: "absolute",
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                },
                top: { xs: "85px", sm: "85px", md: "120px" },
                left: {
                  xs: "15px",
                  sm: "15px",
                  md: "15px",
                  lg: "50px",
                  lgg: "75px",
                  xl: "100px",
                  xll: "120px",
                  xxl: "170px",
                },
              }}
            >
              <Typography
                sx={{
                  padding: "13px 20px",
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  fontSize: "20px !important",
                  width: "fit-content",
                }}
              >
                200+ IT Staffing farms
              </Typography>
            </Box>

            <Box
              sx={{
                position: "absolute",
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                },
                top: "300px",
                left: {
                  xs: "25px",
                  sm: "25px",
                  md: "25px",
                  lg: "30px",
                  lgg: "40px",
                  xl: "60px",
                  xll: "90px",
                  xxl: "130px",
                },
              }}
            >
              <Typography
                sx={{
                  padding: "13px 20px",
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  fontSize: "20px !important",
                  width: "fit-content",
                }}
              >
                12k Bench Sales
              </Typography>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: { xs: "236px", sm: "236px", md: "236px" },
                left: {
                  xs: "400px",
                  sm: "400px",
                  md: "400px",
                  lg: "450px",
                  lgg: "500px",
                  xl: "550px",
                  xll: "600px",
                  xxl: "660px",
                },
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                },
              }}
            >
              <Typography
                sx={{
                  padding: "13px 20px",
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  fontSize: "20px !important",
                  width: "fit-content",
                }}
              >
                10k IT Recruiter
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Fade>

      <Box className={styles.home_structure}>
        <Fade bottom delay={300}>
          {/* <Box
            sx={{
              margin: {
                xs: "20px 0 24px 15px",
                sm: "20px 34px 15px ",
              },
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <Carousel indicators={false}>
                  {carouselItems.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        padding: {
                          xs: "10px 0 0 25px",
                          sm: "35px 0 50px",
                        },
                      }}
                    >
                      <Box sx={{ width: { xs: "100%", sm: "95%" } }}>
                        <Typography
                          variant="h4"
                          sx={{
                            fontSize: "20px !important",
                            fontWeight: "bold",
                          }}
                        >
                          {item.title}
                        </Typography>

                        <Box className={styles.profile_details_views}>
                          <ul
                            style={{
                              padding: "5px 20px",
                              marginBottom: "10px",
                            }}
                          >
                            {item.content.map((contentItem, i) => (
                              <Box key={i}>
                                <li>
                                  <Typography
                                    sx={{ fontSize: "15px !important" }}
                                  >
                                    <b>
                                      {contentItem.heading}
                                      {item.title !== "Who We Are!" && ":"}
                                    </b>
                                    {contentItem.text}
                                  </Typography>
                                </li>
                              </Box>
                            ))}
                          </ul>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Carousel>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Box className={styles.second_details}>
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "300px",
                    }}
                  >
                    <Box className={styles.upto_details}>
                      <b
                      
                      >
                        GET UPTO
                      </b>

                     
                      <Box className={styles.number_details}>
                        <Typography
                          variant="h1"
                          className={styles.first_contain}
                          sx={{
                            fontFamily: "calibri",
                            fontWeight: "600",
                            fontSize: {
                              xs: "100px",
                              md: "120px",
                            },
                            position: "absolute",
                            transform: "translate(-50%, -50%)",
                            margin: 0,
                            color: "transparent",
                            WebkitTextStroke: "2px black",
                          }}
                        >
                          70%
                        </Typography>
                        <Typography
                          variant="h1"
                          className={styles.second_contain}
                          sx={{
                            fontFamily: "calibri",
                            fontWeight: "600",
                            fontSize: {
                              xs: "100px",
                              md: "120px",
                            },
                            position: "absolute",
                            transform: "translate(-50%, -50%)",
                            margin: 0,
                            color: "black",
                            WebkitTextStroke: "2px black",
                         
                            animation: `${waves} 4s ease-in-out infinite`,
                          }}
                        >
                          70%
                        </Typography>
                      </Box>
                      <br />
                      <a>
                        <Box className={styles.text_contain}>
                          Relaxation on your daily workload from recruitment
                          life by using advanced AI powered Povital Job Board
                          and ATS
                        </Box>
                      </a>
                    </Box>

                    <Box className={styles.animation_details}>
                      <WordAnimation />
                    </Box>
                  </Box>
                  <Box className={styles.second_img}>
                    <img
                      src={custom_image}
                      alt="Custom"
                      className={styles.responsiveImage}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box> */}
          <>
            {!isMobile && (
              <Box
              // sx={{ bgcolor: "#3856a6", minHeight: "75vh" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" }, // Stack on small screens, row on larger
                    justifyContent: { xs: "center", md: "space-between" },
                    alignItems: "center",
                    bgcolor: "#fff",
                    color: "#000",
                    // borderRadius: { xs: "0 0 80px 80px", md: "0 0 80px 80px" },
                    height: { xs: "auto", md: "350px" }, // Adjust height for mobile
                    // padding: { xs: "20px", md: "0" },
                    // backgroundImage:
                    //   "linear-gradient(to bottom, rgba(128, 143, 176, 0.75), #f7f7f7 200px);",
                    backgroundOrigin: "border-box",
                    backgroundClip: "content-box, border-box",
                  }}
                >
                  {/* Left Content */}
                  <Box
                    sx={{
                      margin: { xs: "0 0 20px", md: "0 0 90px 80px" },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "24px !important",
                          md: "45px !important",
                        },
                        fontFamily: "Bodoni MT Poster Compressed !important",
                      }}
                    >
                      <b>Did you know?</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px !important",
                          md: "20px !important",
                        },
                        marginTop: "15px",
                      }}
                    >
                      Half an hour of work can be done in 1 minute by using our
                      <br />
                      AI-powered portal.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px !important",
                          md: "20px !important",
                        },
                        marginTop: "15px",
                      }}
                    >
                      Let’s start exploring a beautiful advanced <br />
                      AI-powered platform for free.
                    </Typography>
                  </Box>

                  {/* Image */}
                  <Box
                    sx={{
                      position: "relative",
                      top: { xs: "0" },
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={man}
                      alt="Man illustration"
                      sx={{
                        width: { xs: "80%", md: "100%" }, // Responsive width
                        maxWidth: { xs: "170px", md: "230px" }, // Adjust for mobile vs desktop
                        height: "auto",
                        marginBottom: { xs: "20px", md: "100px" }, // Adjust margin for mobile
                      }}
                    />
                  </Box>

                  {/* Right Content */}
                  <Box
                    sx={{
                      margin: { xs: "0", md: "0 80px 90px 0" },
                      textAlign: { xs: "center", md: "end" },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "24px !important",
                          md: "45px !important",
                        },
                        fontFamily: "Bodoni MT Poster Compressed !important",
                      }}
                    >
                      <b>Ask our users!</b>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px !important",
                          md: "20px !important",
                        },
                        marginTop: "15px",
                      }}
                    >
                      Discuss with our existing users before opening <br />
                      your account with us.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px !important",
                          md: "20px !important",
                        },
                        marginTop: "15px",
                      }}
                    >
                      All effort will be saved in your account after <br />
                      leaving your current company.
                    </Typography>
                  </Box>
                </Box>

                {/* Middle Section */}
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    // borderRadius: "80px 80px 0 0",
                    marginTop: { xs: "60px", md: "165px" },
                    padding: { xs: "0 20px", md: "0 80px" },
                  }}
                >
                  {/* Tabs Navigation */}
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                      "& .MuiTabs-flexContainer": {
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "20px",
                        position: "relative",
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          bottom: "0",
                          width: "90%",
                          height: "1.5px",
                          // backgroundColor: "#f2f2f2",
                        },
                      },
                      "& .MuiTab-root": {
                        textTransform: "capitalize",
                        fontWeight: "bold",
                        fontSize: {
                          xs: "16px !important",
                          sm: "18px !important",
                          md: "20px !important",
                        },
                        padding: { xs: "5px 10px", md: "10px 20px" },
                      },
                      "& .MuiTabs-indicator": {
                        height: "3px",
                        borderRadius: "2px",
                      },
                    }}
                  >
                    {/* <Tab label="Why Choose Us?" /> */}
                    <Tab label="Who We Are?" />
                    <Tab label="What We Offer?" />
                    <Tab label="Our Values" />
                  </Tabs>

                  {/* Tab Content */}
                  {/* {activeTab === 0 && (
                    <Grid container sx={{ margin: { xs: "20px", md: "30px" } }}>
                      <Grid item xs={12} sm={6} md={2.2}>
                        <Box>
                          <img
                            src={why}
                            alt=""
                            style={{
                              width: "100%",
                              maxWidth: "190px",
                              height: "auto",
                              margin: "0 auto",
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={9.8}
                        sx={{ marginTop: { xs: "20px", md: "50px" } }}
                      >
                        <Typography
                          sx={{
                            fontSize: "18px !important",
                          }}
                        >
                          At Povita, we are dedicated to redefining the
                          recruitment process for businesses of all sizes. Our
                          cutting-edge Applicant Tracking System (ATS) is
                          designed to streamline your recruitment workflows,
                          enhance candidate, employees and employer’s day to day
                          experience, and empower to hiring with the tools
                          needed to attract and retain top talent.
                        </Typography>
                      </Grid>
                    </Grid>
                  )} */}
                  {activeTab === 0 && (
                    <Grid
                      container
                      sx={{ margin: { xs: "20px", md: "30px 0" } }}
                    >
                      {/* <Grid item xs={12} sm={6} md={2.2}>
                        <Box>
                          <img
                            src={who}
                            alt=""
                            style={{
                              width: "100%",
                              maxWidth: "190px",
                              height: "auto",
                              margin: "0 auto",
                            }}
                          />
                        </Box>
                      </Grid> */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{
                          marginTop: {
                            xs: "20px",
                            md: "50px",
                            display: "flex",
                            alignItems: "center",
                          },
                        }}
                      >
                        <a
                          style={{
                            fontWeight: "bold",
                            fontSize: "65px",
                            fontFamily: "Bodoni MT Poster Compressed",
                            marginRight: "5px",
                          }}
                        >
                          P
                        </a>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "16px !important",
                              md: "18px !important",
                            },
                          }}
                        >
                          ovital is a leader in the recruitment technology
                          space, bringing together a team of experienced IT
                          recruiters and professionals, software engineers, and
                          industry innovators. Our mission is to simplify and
                          optimize the recruitment process through technology,
                          helping you make data-driven hiring decisions and
                          build a successful workforce.
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  {activeTab === 1 && (
                    <Grid container sx={{ margin: { xs: "20px", md: "30px" } }}>
                      {/* <Grid item xs={12} sm={6} md={2.2}>
                        <Box>
                          <img
                            src={what}
                            alt=""
                            style={{
                              width: "100%",
                              maxWidth: "190px",
                              height: "auto",
                              margin: "0 auto",
                            }}
                          />
                        </Box>
                      </Grid> */}
                      <Grid item xs={12} sm={12} md={12}>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "16px !important",
                              md: "18px !important",
                            },
                          }}
                        >
                          <ul>
                            <li>
                              <b>Streamlined Hiring:</b> Our ATS simplifies
                              every stage of the hiring process, from job
                              posting and application tracking to interview
                              scheduling and candidate management. Experience a
                              seamless workflow that saves you time and reduces
                              manual effort.
                            </li>
                            <li>
                              <b>Enhanced Candidate Experience:</b> Our
                              user-friendly interface ensures a positive
                              experience for candidates, making it easy for them
                              to apply, track their application status, and
                              engage with your brand throughout the hiring
                              journey.
                            </li>
                            <li>
                              <b>Customizable Solutions:</b> Tailor our ATS to
                              fit your unique recruitment needs with flexible
                              features and integrations. Whether you’re a small
                              business or a large enterprise, our platform
                              adapts to your requirements.
                            </li>
                          </ul>
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  {activeTab === 2 && (
                    <Grid container sx={{ margin: { xs: "20px", md: "30px" } }}>
                      {/* <Grid item xs={12} sm={6} md={2.2}>
                        <Box>
                          <img
                            src={our}
                            alt=""
                            style={{
                              width: "100%",
                              maxWidth: "190px",
                              height: "auto",
                              margin: "0 auto",
                            }}
                          />
                        </Box>
                      </Grid> */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{ marginTop: { xs: "20px", md: "50px" } }}
                      >
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "16px !important",
                              md: "18px !important",
                            },
                          }}
                        >
                          <ul>
                            <li>
                              <b>Innovation:</b> We are committed to
                              continuously enhancing our platform with the
                              latest technology and features to stay ahead in
                              the rapidly evolving recruitment landscape.
                            </li>
                            <li>
                              <b>Customer Success:</b> We prioritize your
                              success by providing exceptional support and
                              ensuring our ATS meets your specific needs and
                              expectations.
                            </li>
                          </ul>
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Box>
            )}

            {isMobile && (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  // bgcolor: "#3856a6",
                  // minHeight: "10vh",
                  overflow: "hidden",
                }}
              >
                {/* Did You Know Section */}
                <Box
                  sx={{
                    p: 1.5,
                    backgroundColor: "#ffffff",
                    borderRadius: "0 0 30px 30px",
                  }}
                >
                  <Typography sx={{ mb: 0.5, fontSize: "22px !important" }}>
                    <b>Did you know?</b>
                  </Typography>
                  <Typography sx={{ fontSize: "12px" }}>
                    {" "}
                    {/* Reduced font size */}
                    Half an hour's work can be done in 1 minute using our
                    AI-powered portal.
                  </Typography>
                  <Typography sx={{ mt: 0.5, fontSize: "12px" }}>
                    {" "}
                    {/* Reduced spacing */}
                    Let’s start exploring a beautiful advanced AI-powered
                    platform for free.
                  </Typography>

                  {/* Image Section */}
                  <Box sx={{ textAlign: "center" }}>
                    {" "}
                    {/* Reduced padding */}
                    <Box
                      component="img"
                      src={man}
                      alt="Man illustration"
                      sx={{
                        width: "80%",
                        maxWidth: "150px",
                        height: "auto",
                        position: "relative",
                        top: "90px",
                      }}
                    />
                  </Box>
                </Box>

                {/* Ask Our Users Section */}
                <Box
                  sx={{
                    p: 2,
                    backgroundColor: "#ffffff",
                    borderRadius: "30px 30px 0 0",
                    marginTop: "100px",
                  }}
                >
                  <Typography sx={{ mb: 1, fontSize: "22px !important" }}>
                    <b> Ask our users!</b>
                  </Typography>
                  <Typography sx={{ fontSize: "27px !important" }}>
                    Discuss with our existing users before opening your account
                    with us.
                  </Typography>
                  <Typography sx={{ mt: 1, fontSize: "14px !important" }}>
                    All effort will be saved in your account after leaving the
                    current company.
                  </Typography>
                </Box>

                {/* Tab Section */}
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    maxWidth: 400,
                    mx: "auto",
                    p: 2,
                  }}
                >
                  {/* Tabs Navigation */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {tabValue > 0 && (
                      <IoIosArrowBack
                        onClick={() => handleArrowClick("prev")}
                        style={{
                          cursor: "pointer",
                          fontSize: "24px",
                          color: "#666",
                        }}
                      />
                    )}
                    <Tabs
                      value={tabValue}
                      onChange={handleTabsChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      sx={{
                        "& .MuiTab-root": {
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          fontSize: "16px !important",
                          padding: "5px 10px",
                        },
                        "& .MuiTabs-indicator": {
                          height: "3px",
                          borderRadius: "2px",
                        },
                      }}
                    >
                      <Tab label="Why Choose Us?" />
                      <Tab label="Who We Are?" />
                      <Tab label="What We Offer?" />
                      <Tab label="Our Values" />
                    </Tabs>
                    {tabValue < 3 && (
                      <IoIosArrowForward
                        onClick={() => handleArrowClick("next")}
                        style={{
                          cursor: "pointer",
                          fontSize: "24px",
                          color: "#666",
                        }}
                      />
                    )}
                  </Box>

                  <Divider />

                  {/* Swipeable Views with Auto Height */}
                  <SwipeableViews
                    index={tabValue}
                    onChangeIndex={setTabValue}
                    enableMouseEvents
                    animateHeight
                  >
                    {/* Tab 1 Content */}
                    <Box sx={{ p: 2 }}>
                      <Typography sx={{ fontSize: "14px" }}>
                        At Povita, we are dedicated to redefining the
                        recruitment process for businesses of all sizes. Our
                        cutting-edge Applicant Tracking System (ATS) is designed
                        to streamline your recruitment workflows, enhance
                        candidate, employees and employer’s day to day
                        experience, and empower to hiring with the tools needed
                        to attract and retain top talent.
                      </Typography>
                    </Box>

                    {/* Tab 2 Content */}
                    <Box sx={{ p: 2 }}>
                      {/* <span style={{ fontWeight: "bold", fontSize: "35px" }}>
                        P
                      </span> */}
                      <Typography sx={{ fontSize: "14px" }}>
                        Povital is a leader in the recruitment technology space,
                        bringing together a team of experienced IT recruiters
                        and professionals, software engineers, and industry
                        innovators. Our mission is to simplify and optimize the
                        recruitment process through technology, helping you make
                        data-driven hiring decisions and build a successful
                        workforce.
                      </Typography>
                    </Box>

                    {/* Tab 3 Content */}
                    <Box sx={{ p: 2 }}>
                      <Typography sx={{ fontSize: "14px" }}>
                        <ul>
                          <li>
                            <b>Streamlined Hiring:</b> Our ATS simplifies every
                            stage of the hiring process, from job posting and
                            application tracking to interview scheduling and
                            candidate management. Experience a seamless workflow
                            that saves you time and reduces manual effort.
                          </li>
                          <li>
                            <b>Enhanced Candidate Experience:</b> Our
                            user-friendly interface ensures a positive
                            experience for candidates, making it easy for them
                            to apply, track their application status, and engage
                            with your brand throughout the hiring journey.
                          </li>
                          <li>
                            <b>Customizable Solutions:</b> Tailor our ATS to fit
                            your unique recruitment needs with flexible features
                            and integrations. Whether you’re a small business or
                            a large enterprise, our platform adapts to your
                            requirements.
                          </li>
                        </ul>
                      </Typography>
                    </Box>

                    {/* Tab 4 Content */}
                    <Box sx={{ p: 2 }}>
                      <Typography sx={{ fontSize: "14px" }}>
                        <ul>
                          <li>
                            <b>Innovation:</b> We are committed to continuously
                            enhancing our platform with the latest technology
                            and features to stay ahead in the rapidly evolving
                            recruitment landscape.
                          </li>
                          <li>
                            <b>Customer Success:</b> We prioritize your success
                            by providing exceptional support and ensuring our
                            ATS meets your specific needs and expectations.
                          </li>
                        </ul>
                      </Typography>
                    </Box>
                  </SwipeableViews>
                </Box>
              </Box>
            )}
          </>

          <>
            {/* Desktop and Laptop Design */}
            {!isMobile && (
              <Box
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "20px",
                  margin: "50px 80px",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                }}
              >
                <Grid container alignItems="center" spacing={2}>
                  {/* Left Section */}
                  <Grid item xs={12} sm={6} md={2.5} lg={2.5}>
                    <Box className={styles.upto_details}>
                      <b>GET UPTO</b>
                    </Box>
                    <Box className={styles.number_details}>
                      <Typography
                        variant="h1"
                        className={styles.first_contain}
                        sx={{
                          fontFamily: "calibri",
                          fontWeight: "600",
                          fontSize: "130px",

                          position: "absolute",
                          transform: "translate(-50%, -50%)",
                          margin: 0,
                          color: "transparent",
                          WebkitTextStroke: "2px black",
                        }}
                      >
                        70%
                      </Typography>
                      <Typography
                        variant="h1"
                        className={styles.second_contain}
                        sx={{
                          fontFamily: "calibri",
                          fontWeight: "600",
                          fontSize: "130px",

                          position: "absolute",
                          transform: "translate(-50%, -50%)",
                          margin: 0,
                          color: "black",
                          WebkitTextStroke: "2px black",

                          animation: `${waves} 4s ease-in-out infinite`,
                        }}
                      >
                        70%
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Middle Section */}
                  <Grid item xs={12} sm={6} md={5.5} lg={5.5}>
                    <Typography sx={{ fontSize: "18px !important" }}>
                      Relaxation on your daily workload from recruitment life by
                      using our advanced AI-powered platform.
                    </Typography>
                    <Box className={styles.animation_details}>
                      <WordAnimation />
                    </Box>
                  </Grid>

                  {/* Right Section */}
                  <Grid item xs={12} sm={6} md={4} lg={4}>
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                      <img src={value} alt="" width="150px" height="130px" />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* Mobile Design */}
            {isMobile && (
              <Box
                style={{
                  backgroundColor: "#f7f7f7",
                  padding: "15px",
                }}
              >
                <Box className={styles.upto_details}>
                  <b>GET UPTO</b>
                </Box>
                <Box className={styles.number_details}>
                  <Typography
                    variant="h1"
                    className={styles.first_contain}
                    sx={{
                      fontFamily: "calibri",
                      fontWeight: "600",
                      fontSize: "90px",

                      position: "absolute",
                      transform: "translate(-50%, -50%)",
                      margin: 0,
                      color: "transparent",
                      WebkitTextStroke: "2px black",
                    }}
                  >
                    70%
                  </Typography>
                  <Typography
                    variant="h1"
                    className={styles.second_contain}
                    sx={{
                      fontFamily: "calibri",
                      fontWeight: "600",
                      fontSize: "90px",

                      position: "absolute",
                      transform: "translate(-50%, -50%)",
                      margin: 0,
                      color: "black",
                      WebkitTextStroke: "2px black",

                      animation: `${waves} 4s ease-in-out infinite`,
                    }}
                  >
                    70%
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    fontSize: "14px !important",
                    marginLeft: "170px",
                  }}
                >
                  Relaxation on your daily workload from recruitment life by
                  using our advanced AI-powered platform.
                </Typography>

                <Box>
                  <WordAnimation />
                </Box>
              </Box>
            )}
          </>
        </Fade>

        <Fade bottom delay={300}>
          <Box className={styles.feedback_section} id="platform">
            <Grid container>
              <Grid item xs={12} sm={6} md={8} lg={8}>
                <Box sx={{ width: { xs: "100%", sm: "90%" } }}>
                  <h4
                    style={{
                      marginBottom: "34px",
                      fontSize: "20px !important",
                      marginTop: "40px",
                    }}
                  >
                    <b>Feedback from Users!</b>
                  </h4>

                  <Carousel>
                    {feedbacks.map((feedback, index) => (
                      <Box key={index} className={styles.feedbackItem}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <img
                            src={feedback.profileImage}
                            alt=""
                            width="75px"
                            height="75px"
                            style={{
                              borderRadius: "50%",
                              marginRight: "20px",
                              border: "3.5px solid #fff",
                            }}
                          />
                          <span style={{ width: "100%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "14px !important",
                                    sm: "18px !important",
                                  },
                                }}
                              >
                                <Box
                                  component="b"
                                  sx={{
                                    display: {
                                      xs: "none",
                                      sm: "block",
                                    },
                                  }}
                                >
                                  {feedback.name}
                                </Box>

                                <Box
                                  component="b"
                                  sx={{
                                    display: {
                                      xs: "block",
                                      sm: "none",
                                    },
                                  }}
                                >
                                  {feedback.names}
                                </Box>

                                <Box
                                  component="b"
                                  sx={{
                                    display: {
                                      xs: "block",
                                      sm: "none",
                                    },
                                  }}
                                >
                                  {feedback.designation}
                                </Box>
                              </Typography>

                              {/* <Typography
                                sx={{
                                  fontSize: {
                                    xs: "14px !important",
                                    sm: "18px !important",
                                  },
                                  display: {
                                    xs: "block",
                                    sm: "none",
                                  },
                                }}
                              >
                                <b>{feedback.designation}</b>                             
                              </Typography> */}
                              <Box>
                                {[...Array(feedback.rating)].map((_, i) => (
                                  <IoStar
                                    key={i}
                                    style={{
                                      fontSize: "20px",
                                      color: "#fccc51",
                                    }}
                                  />
                                ))}

                                {feedback.rating === 4 && (
                                  <IoStar
                                    style={{
                                      fontSize: "20px",
                                      color: "#b8b7b7",
                                    }}
                                  />
                                )}
                                {feedback.rating === 3 && (
                                  <>
                                    <IoStar
                                      style={{
                                        fontSize: "20px",
                                        color: "#b8b7b7",
                                      }}
                                    />
                                    <IoStar
                                      style={{
                                        fontSize: "20px",
                                        color: "#b8b7b7",
                                      }}
                                    />
                                  </>
                                )}
                              </Box>
                            </Box>
                            <Typography
                              sx={{
                                color: "gray",
                                fontSize: {
                                  xs: "14px !important",
                                  sm: "18px !important",
                                },
                              }}
                            >
                              Date: {feedback.date}
                            </Typography>
                          </span>
                        </Box>

                        <Typography
                          sx={{
                            paddingTop: "5px",
                            fontSize: {
                              xs: "14px !important",
                              sm: "18px !important",
                            },
                          }}
                        >
                          {feedback.comment}
                        </Typography>
                      </Box>
                    ))}
                  </Carousel>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                className={styles.review_details}
              >
                <Box className={styles.servies_requirement}>
                  <img src={write} alt="" width="90px" height="90px" />
                  <span>
                    <button
                      style={{ marginBottom: "40px" }}
                      className={styles.centerButton}
                      onClick={() => navigate("/login")}
                    >
                      Write Review
                    </button>
                    <Box sx={{ marginBottom: "20px" }}>
                      <IoStar style={{ fontSize: "23px", color: "#fccc51" }} />
                      <IoStar style={{ fontSize: "23px", color: "#fccc51" }} />
                      <IoStar style={{ fontSize: "23px", color: "#fccc51" }} />
                      <IoStar style={{ fontSize: "23px", color: "#fccc51" }} />
                      <IoStar style={{ fontSize: "23px", color: "#fccc51" }} />
                    </Box>
                    <Typography>
                      <b>
                        <Typography sx={{ fontSize: "19px !important" }}>
                          Always our user top priority for Us, please
                        </Typography>
                      </b>
                    </Typography>
                    <Typography
                      sx={{ marginBottom: "50px", fontSize: "16px !important" }}
                    >
                      write a review
                    </Typography>
                  </span>
                </Box>
              </Grid>
              <span
                className={styles.view_profile_link}
                onClick={() => navigate("/feedback-more")}
              >
                View More
              </span>
            </Grid>
          </Box>
        </Fade>

        <Fade bottom delay={200}>
          <Box
            sx={{
              backgroundColor: "#2D4696",

              padding: { xs: "15px", md: "0" },
              marginBottom: "50px",
            }}
          >
            <Grid
              container
              sx={{
                alignSelf: "center",
                width: "100%",
                marginTop: { xs: "0", md: "0" },
              }}
              spacing={2} // Add spacing between Grid items for better mobile view
            >
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box className={styles.image_contain}>
                  <img
                    src={Profile_picture}
                    alt="Profile"
                    style={{ width: "100%", maxWidth: "200px", height: "auto" }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={9}
                lg={9}
                sx={{
                  margin: { xs: "20px 0 0 0", sm: "0" }, // Add margin on small devices
                  padding: { xs: "10px" }, // Add some padding on smaller screens
                }}
              >
                <Box className={styles.povital_contain}>
                  <Typography>
                    <Box>
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: "bold",

                          fontSize: {
                            xs: "30px",
                            md: "35px",
                          },
                          color: "#fff",
                          position: "relative",
                          left: "15px",
                          bottom: { xs: "35px", md: "20px" },
                          fontFamily: "Bodoni MT Poster Compressed !important",
                        }}
                      >
                        Why go with Povital?
                      </Typography>

                      {/* <Typography
                        variant="h2"
                        sx={{
                          position: "relative",
                          color: "#34a853",
                          fontWeight: "600",
                          fontFamily: "Helvetica",
                          fontSize: {
                            xs: "30px",
                            md: "50px",
                          },
                          textShadow: "1px 1px 1px black, -1px -1px 1px black",
                          position: "absolute",
                          top: "0",
                          width: "100%",
                          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
                          animation: `${textAnimation} 10s ease-in-out forwards alternate infinite`,
                        }}
                      >
                        Why go with Povital?
                      </Typography> */}

                      {/* <Typography
                        variant="h2"
                        sx={{
                          position: "relative",
                          color: "transparent",
                          fontWeight: "600",
                          fontFamily: "Helvetica",
                          fontSize: {
                            xs: "30px",
                            md: "50px",
                          },
                          top: "0",
                          height: "20%",
                          width: "100%",
                        }}
                      >
                        Why go with Povital
                      </Typography> */}
                    </Box>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "15px !important",
                        md: "19px !important",
                      },
                      position: "relative",
                      top: { xs: "0", md: "15px" },
                      left: { xs: "10px" },

                      color: "#fff",
                    }}
                  >
                    Because staffing professionals know about our features and
                    services.
                    <br className={styles.resposive_break} />
                    that even with the best AI technology is only as good as the
                    people behind it. That's why we
                    <br className={styles.resposive_break} />
                    offer the best user-friendly platform.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>

        {/* <Fade bottom delay={200}>
          <Box className={styles.services_Requirements}>
            <Typography sx={{ fontSize: "20px !important", margin: "15px" }}>
              <b>Services Available on Demand!</b>
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px !important",
                    sm: "20px !important",
                  },
                }}
              >
                100% happy client in last 10 Years Journey.
              </Typography>
            </Typography>

            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: "10px" }}>
                <Box sx={{ position: "relative", borderRadius: "3px" }}>
                  <img
                    src={responsive_web}
                    alt="Responsive Web Design"
                    className={styles.responsive_image}
                  />
                  <Box className={styles.website_job_Requirements}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "19px !important" }}
                    >
                      Website Designee
                    </Typography>
                    <Typography sx={{ fontSize: "19px !important" }}>
                      Responsive in all devices.
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: "10px" }}>
                <Box sx={{ position: "relative", borderRadius: "3px" }}>
                  <img
                    src={web_design}
                    alt="Web Application Design"
                    className={styles.responsive_image}
                  />
                  <Box className={styles.website_job_Requirements}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "19px !important" }}
                    >
                      Web & Mobile App Development
                    </Typography>
                    <Typography sx={{ fontSize: "19px !important" }}>
                      Highly secure and supporting in all devices
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: "10px" }}>
                <Box sx={{ position: "relative", borderRadius: "3px" }}>
                  <img
                    className={styles.responsive_image}
                    src={digital_marketing}
                    alt="Digital Marketing"
                  />
                  <Box className={styles.website_job_Requirements}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "19px !important" }}
                    >
                      Digital Marketing & SEO
                    </Typography>
                    <Typography sx={{ fontSize: "19px !important" }}>
                      100% result assurance
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
        <Fade bottom delay={200}>
          <Box
            sx={{
              margin: {
                xs: " 0 5px 24px",
                sm: "0 0 5px 24px",
              },
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                sx={{ margin: "14px 0", padding: "20px" }}
              >
                <Typography
                  sx={{ marginBottom: "15px", fontSize: "20px !important" }}
                >
                  <b>Paid Services Available at Mythee’s </b>
                </Typography>

                <Typography
                  sx={{
                    fontSize: {
                      xs: "15px !important",
                      sm: "19px !important",
                    },
                  }}
                >
                  Mythee holding more than 10 years of excellency in
                  <br /> Software Development filed
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={8}
                lg={8}
                className={styles.job_details}
              >
                <span>
                  <GoTasklist style={{ fontSize: "40px" }} />
                  <span>
                    <a style={{ fontSize: "19px" }}>
                      <b>Inventory Management</b>
                    </a>
                    <Typography sx={{ color: "#767171" }}>
                      Laravel 11 Framework
                    </Typography>
                  </span>
                </span>
                <span>
                  <LiaUserTieSolid style={{ fontSize: "40px" }} />
                  <a style={{ fontSize: "19px" }}>
                    <b>HRM – Payrolls</b>
                  </a>
                  <Typography sx={{ color: "#767171" }}>
                    Node JS & React JS
                  </Typography>
                </span>
                <span>
                  <PiSailboat style={{ fontSize: "40px" }} />
                  <a style={{ fontSize: "19px" }}>
                    <b>Boating Management</b>
                  </a>
                  <Typography sx={{ color: "#767171" }}>
                    Java, Angular
                  </Typography>
                </span>
              </Grid>
            </Grid>
          </Box>
        </Fade> */}

        <Box>
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Home;
